import {match} from 'ts-pattern';

import {isString} from 'ramda-adjunct';

import i18n from '@dms/i18n';
import {testIds, warehouseRoutes} from '@dms/routes';
import {catchUnhandledDataGridActions, DmsDataGrid, logError} from '@dms/shared';

import {composePath, useNavigate} from 'shared/web';

import type {ActionCallback} from 'features/eag-grid';

const RMA_REQUEST_GRID_CODE = 'warehouse_rma_request_list';

export function RmaRequestList() {
  const navigate = useNavigate();

  const actionCallback: ActionCallback = ({actionKey, rowId, sourceSearchParams}) => {
    if (!isString(rowId)) {
      return logError(`Bulk invocation of single-row action ${actionKey} is not implemented`);
    }

    match(actionKey)
      .with('edit', 'redirectDetail', () =>
        navigate(
          composePath(warehouseRoutes.rmaRequestDetailOverview, {
            params: {id: rowId},
            queryParams: sourceSearchParams,
            isSearchParamsPreserved: false,
          })
        )
      )
      .otherwise(() => catchUnhandledDataGridActions(actionKey));
  };

  return (
    <DmsDataGrid
      gridCode={RMA_REQUEST_GRID_CODE}
      actionCallback={actionCallback}
      emptyState={{headline: i18n.t('page.warehouse.labels.noRmaRequests')}}
      data-testid={testIds.warehouse.rmaRequestList('datagrid')}
    />
  );
}
